//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//

/** @public */
export type ContextTransformFieldType = (
  'calendar-field'| 'currencyName'| 'day-format-except-narrow'
| 'day-standalone-except-narrow'| 'era-abbr'| 'era-name'| 'keyValue'
| 'languages'| 'month-format-except-narrow'| 'month-standalone-except-narrow'
| 'number-spellout'| 'relative'| 'script'| 'typographicNames');
